const displayTabletModeModel = {
    state: {
        mode: 'DEFAULT',
    },

    reducers: {
        setDefaultMode: state => {
            return { ...state, mode: 'DEFAULT' };
        },
        setDrawMode: state => {
            return { ...state, mode: 'DRAW' };
        },
    },

    selectors: slice => ({
        isDefaultMode() {
            return slice(model => model.mode === 'DEFAULT');
        },
        isDrawMode() {
            return slice(model => model.mode === 'DRAW');
        },
    }),

    effects: dispatch => ({
        setDrawEffect() {
            dispatch.inspector.reset();
            this.setDrawMode();
        },
        setDefaultEffect() {
            dispatch.inspector.reset();
            this.setDefaultMode();
        },
    }),
};

export default displayTabletModeModel;
